import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchWrapper } from "../_helpers";

// Create slice
const name = "master";
const initialState = createInitialState();
const extraActions = createExtraActions();
const reducers = createReducers();
const slice = createSlice({
  name,
  initialState,
  reducers,
  extraReducers: (builder) => {
    createExtraReducers(builder);
  },
});

// Exports
export const masterActions = { ...slice.actions, ...extraActions };
export const masterReducer = slice.reducer;

// Helper functions

function createInitialState() {
  return {
    stateDrpList: [], // State for State List
    facilityDrpList: [], // State for Facility List
    facilityStateList: [],
    currentMenuName: "Inbox",
    loading: false,
    error: null,
  };
}

function createReducers() {
  return {
    updateCurrentName,
  };

  function updateCurrentName(state, action) {
    state.currentMenuName = action.payload;
  }
}

function createExtraActions() {
  const baseUrl = `${process.env.REACT_APP_API_URL}/Common`;
  const facilityStateBaseUrl = `${process.env.REACT_APP_API_URL}/Master`;

  return {
    GetStateList: GetStateList(),
    GetFacilityList: GetFacilityList(),
    GetApplicationSettings: GetApplicationSettings(),
    GetFacilityStateList: GetFacilityStateList(),
  };

  // Function for get all state values
  function GetStateList() {
    return createAsyncThunk(
      `${name}/GetState`,
      async () => await fetchWrapper.get(`${baseUrl}/GetAllStates`)
    );
  }

  // Function for get Facility
  function GetFacilityList() {
    return createAsyncThunk(
      `${name}/GetFacility`,
      async (stateID) =>
        await fetchWrapper.get(
          `${baseUrl}/LoadPublicUserSearchFacilityName?facilityStateID=${stateID}`
        )
    );
  }

  function GetApplicationSettings() {
    return createAsyncThunk(
      `${name}/GetApplicationSettings`,
      async (appName) =>
        await fetchWrapper.get(
          `${baseUrl}/GetApplicationSettings?appName=${appName}`
        )
    );
  }

  // Function for get all state values
  function GetFacilityStateList() {
    return createAsyncThunk(
      `${name}/GetFacilityMappedStateList`,
      async () =>
        await fetchWrapper.get(
          `${facilityStateBaseUrl}/GetFacilityMappedStateList`
        )
    );
  }
}

function createExtraReducers(builder) {
  builder

    //Reducer for StateList
    .addCase(extraActions.GetStateList.pending, (state) => {
      state.loading = true;
    })
    .addCase(extraActions.GetStateList.fulfilled, (state, action) => {
      state.stateDrpList = action.payload;
      state.loading = false;
    })
    .addCase(extraActions.GetStateList.rejected, (state, action) => {
      state.error = action.error.message;
      state.loading = false;
    })

    // Reducer for Facility List
    .addCase(extraActions.GetFacilityList.pending, (state) => {
      state.loading = true;
    })
    .addCase(extraActions.GetFacilityList.fulfilled, (state, action) => {
      state.facilityDrpList = action.payload;
      state.loading = false;
    })
    .addCase(extraActions.GetFacilityList.rejected, (state, action) => {
      state.error = action.error.message;
      state.loading = false;
    })
    //GetApplicationSettings Maintainance
    .addCase(extraActions.GetApplicationSettings.pending, (state) => {
      state.loading = true;
    })
    .addCase(extraActions.GetApplicationSettings.fulfilled, (state, action) => {
      state.maintenanceMode = action.payload;
      state.loading = false;
    })
    .addCase(extraActions.GetApplicationSettings.rejected, (state, action) => {
      state.error = action.error.message;
      state.loading = false;
    })

    //GetApplicationSettings Maintainance
    .addCase(extraActions.GetFacilityStateList.pending, (state) => {
      state.loading = true;
    })
    .addCase(extraActions.GetFacilityStateList.fulfilled, (state, action) => {
      state.facilityStateList = action.payload;
      state.loading = false;
    })
    .addCase(extraActions.GetFacilityStateList.rejected, (state, action) => {
      state.error = action.error.message;
      state.loading = false;
    });
}
